module.exports = __webpack_public_path__ + "static/media/Shop-By-Tire-Brand.c0f2ff32.svg";